define('shared/helpers',[],function () {
	
	var Helpers = function Helpers() {};

	Helpers.prototype.CHECKBOX_INACTIVE = "/images/checkbox-inactive.svg";
	Helpers.prototype.CHECKBOX_ACTIVE = "/images/checkbox-checked.svg";

	Helpers.prototype.is_third_party_data = function (obj) {
		if (typeof obj.source === "undefined") {
			throw new Error("Object does not have a source attribute.");
		}
		return !(obj.source == "tenant" || obj.source == "csvimport");
	};

	Helpers.prototype.ping_generator = function (url, onSuccess, onFailure) {
		return function ping(attempt) {
			if (attempt >= 400) {
				onFailure("Request timed out.");
				return;
			} else if (attempt == 30) {
				$(".loadingMessage").html("Still running...");
			} else if (attempt == 60) {
				$(".loadingMessage").html("This can take up to 10 minutes, please wait.");
			} else if (attempt == 150) {
				$(".loadingModal").html("Wow you have a lot of data! Almost done...");
			}

			window.api.custom(url)
			.execute()
			.done(function (data, textStatus, jqXHR) {
				var statusCode = jqXHR.statusCode().status;
				if (statusCode == 200) {
					// Job finished...
					onSuccess();
				} else {
					// Wait, then ping again.
					setTimeout(function () {
						ping(attempt + 1);
					}, 5000);
				}
			})
			.fail(function (jqXHR, textStatus, errorThrown) {
				var statusCode = jqXHR.statusCode().status;
				if (JSON.parse(jqXHR.responseText).data.hasOwnProperty('response') && JSON.parse(jqXHR.responseText).data.response === "403") {
					// Message will have to be updated.
					onFailure("Oops, You do not have sufficient permission to sync the users. Please contact your admin to approve the permission");
				} else if (statusCode == 422) {
					onFailure("Synchronization failed. Please contact support.");
				} else {
					// Wait, then ping again.
					setTimeout(function () {
						ping(attempt + 1);
					}, 5000);
				}
			});
		}
	}

	Helpers.prototype.is_student_regex_check = function (userInfo) {
		// stundents|studdents look like typos but they are actually user-inputted matches we found in Salesforce
		if (/(\b\w*(student|pupil|estudiante|estudiant|alumno|eleve|students|stundents|studdents)\w*\b)|(\b(stu.)\b)/.test(userInfo)) {
			return true;
		}
		return false;
	}

	return new Helpers();
});
